// extracted by mini-css-extract-plugin
export default {"button":"SubscribeButton_button__XxaJs"};